<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative">
           
            <div class="z-index pb-2">
                <div class="row mx-0 m-col-width">
                    <div class="col-md-6 col-sm-12 px-0 m-mb">
                        <div class="whats-new-label dark-banner">
                            <div class="wave-container">
                                <div class="wave-dot wave-dot-1"></div> 
                                <div class="wave-dot wave-dot-3"></div> 
                            </div> 
                            <span class="primary-color paragraph-global-text sub-head-paragraph">
                                {{'meetings.banner.preTitle' | translate}}
                            </span>
                        </div>
        
                        <h1 class="banner-heading mw-700">{{'meetings.banner.headline1' | translate}} {{'meetings.banner.headline2' | translate}}</h1>
                        <p class="paragraph-global-text mw-500">{{'meetings.banner.subheadline' | translate}}</p>
                       <div class="d-flex align-items-center my-3">
                            <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                                <button class="save-btn cfa">
                                    {{'meetings.banner.ctaButtons.btnText' | translate}}
                                    <i class="pi pi-arrow-right title-color ml-2"></i>
                                </button>
                            </a>
                       </div>                      
                    </div>
                    <div class="col-md-6 col-sm-12 pr-0 d-flex align-items-center">
                        <figure>
                            <img class="w-100 pl-4" width="300" src="../../../assets/icons/find-answers/find-answer-banner.svg" alt="find answers">
                        </figure>
                    </div>
                </div>                
            </div>           
        </div>
    </div>
</div>


<div class="sec-padding">    
    <div class="container z-index">
        <div class="text-center pb-3 mb-5">
            <h2 class="heading-one mx-auto mw-900">{{'meetings.bringTeam.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800">{{'meetings.bringTeam.description' | translate}}</p>
        </div>
        <div class="text-center">
            <h4 class="heading-three mx-auto mw-900 mb-5 pb-2">{{'meetings.bringTeam.subTitle' | translate}}</h4>
        </div>
        <div class="row mx-0 m-col-w card-v-gap justify-content-between">
            <div class="col-md-5 col-sm-12 d-flex align-items-center">
                <figure>
                    <img class="card-image w-100 box-shadow border-radius" src=".././../../assets/icons/find-insights/find-insights-sec-img.svg" alt="card-image">
                </figure>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="cards-sec">
                    <div class="card lft-img-card border-bottom">
                        <div>
                            <h4 class="heading-three">{{"meetings.bringTeam.section1.title" | translate}}</h4>
                            <p class="paragraph-global-text">{{"meetings.bringTeam.section1.description" | translate}}</p>
                        </div>
                    </div>
                    <div class="card lft-img-card border-bottom">
                        <div>
                            <h4 class="heading-three">{{"meetings.bringTeam.section2.title" | translate}}</h4>
                            <p class="paragraph-global-text">{{"meetings.bringTeam.section2.description" | translate}}</p>
                        </div>
                    </div>
                    <div class="card lft-img-card">
                        <div>
                            <h4 class="heading-three">{{"meetings.bringTeam.section3.title" | translate}}</h4>
                            <p class="paragraph-global-text">{{"meetings.bringTeam.section3.description" | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="sec-padding secondary-bg-color">    
    <div class="container z-index">
        <div class="text-center pb-3 mb-5">
            <h2 class="heading-one mx-auto mw-900">{{'meetings.meetNotes.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800">{{'meetings.meetNotes.description' | translate}}</p>
        </div>
        <div class="quateCard text-center">
            <img class="mx-auto mb-3" style="width: 4rem;" src="../../../assets/icons/collaboration-features/quate.svg" alt="">
            <h4 class="heading-two mx-auto mw-900">{{'meetings.meetNotes.section1.title' | translate}}</h4>
            <p class="paragraph-global-text sub-head-paragraph mw-750 mb-5">{{'meetings.meetNotes.section1.description' | translate}}</p>
            <h4 class="heading-three mx-auto mw-900 mb-1">{{'meetings.meetNotes.section1.subTitle' | translate}}</h4>
            <p class="paragraph-global-text sub-head-paragraph mw-800 mb-0">{{'meetings.meetNotes.section1.subDescription' | translate}}</p>
        </div>
    </div>
</div>



<div class="sec-padding">    
    <div class="container z-index">
        <div class="text-center pb-3 mb-5">
            <h2 class="heading-one mx-auto">{{'meetings.teamCommunication.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800">{{'meetings.teamCommunication.description' | translate}}</p>
        </div>
        <div class="row mx-0 m-col-w card-v-gap justify-content-between">
            <div class="col-md-5 col-sm-12 d-flex align-items-center">
                <figure>
                    <img class="card-image w-100 box-shadow border-radius" src=".././../../assets/icons/find-insights/find-insights-sec-img.svg" alt="card-image">
                </figure>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="cards-sec">
                    <div class="card lft-img-card border-bottom">
                        <div>
                            <h4 class="heading-three">{{"meetings.teamCommunication.section1.title" | translate}}</h4>
                            <p class="paragraph-global-text">{{"meetings.teamCommunication.section1.description" | translate}}</p>
                        </div>
                    </div>
                    <div class="card lft-img-card border-bottom">
                        <div>
                            <h4 class="heading-three">{{"meetings.teamCommunication.section2.title" | translate}}</h4>
                            <p class="paragraph-global-text">{{"meetings.teamCommunication.section2.description" | translate}}</p>
                        </div>
                    </div>
                    <div class="card lft-img-card">
                        <div>
                            <h4 class="heading-three">{{"meetings.teamCommunication.section3.title" | translate}}</h4>
                            <p class="paragraph-global-text">{{"meetings.teamCommunication.section3.description" | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


 <!-- faqs  -->
 <div class="sec-padding mcqs-sec secondary-bg-color">
    <div class="container">
      <div class="text-center mb-5 pb-4">
        <div class="content-sec">
          <h1 class="heading-one">
            {{'meetings.faq.title' | translate}}
            {{'meetings.faq.title2' | translate}}
          </h1>
        </div>
      </div>
  
      <div class="accordion mw-800 mx-auto">
        <app-simple-expansion [panels]="projectProgressOptions"></app-simple-expansion>
      </div>
      <div>
        <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
            <button class="save-btn mx-auto fw-500 mt-4">
                {{'meetings.faq.buttonTxt' | translate}}
            </button>
        </a>
    </div>
    </div>
  </div> 

  <div class="sec-padding cfa-sec position-relative">    
      <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">
            <h2 class="heading-one text-white mx-auto">{{'meetings.cfa.title' | translate}} </h2>
            <p class="paragraph-global-text sub-head-paragraph mw-850 text-white">{{'meetings.cfa.description' | translate}}</p>
  
            <div class="button-container mt-4">
                <a class="save-btn cfa btn" [routerLink]="'en/book-demo'" target="_blank">
                    {{'meetings.cfa.buttonTxt' | translate}}
                </a>
            </div>
        </div>
    </div>
  </div>